/*
 * Le sélecteur variant-picker équipé de data-option-state gère déjà les variantes.
 * Ne pas lui appliquer le filtre historique fondé sur le texte des labels :
 * les badges RÉSA modifient ce texte et provoquent un faux blocage des clics.
 * Recharger complètement la page après remplacement pour arrêter les anciens timers.
/**
 * Shopify Variant Filter - Version finale propre
 */
(function(){"use strict";let updateTimeout=null,isUpdating=!1,lastSelection=null;function initVariantFilter(){if(document.querySelector("variant-picker script[data-option-state]"))return;if(!window.ShopifyProduct||!window.ShopifyProduct.variants)return;const product=window.ShopifyProduct,variants=product.variants;function resetAllStyles(){const allLabels=document.querySelectorAll('.product-form__input label, input[type="radio"][name*="option"] + label, input[type="radio"][name*="option"] ~ label'),allInputs=document.querySelectorAll('input[type="radio"][name*="option"]');allLabels.forEach(label=>{label.style.opacity="",label.style.cursor="",label.style.pointerEvents="",label.classList.remove("variant-disabled")}),allInputs.forEach(input=>{input.disabled=!1})}function findOptionGroups(){const groups=[];return document.querySelectorAll(".product-form__input label, fieldset legend, .variant-picker__label").forEach(label=>{const text=label.textContent.trim().replace(":","");if(product.options.includes(text)){const optionIndex=product.options.indexOf(text),container=label.closest(".product-form__input, fieldset, .variant-picker");if(container){const radios=container.querySelectorAll('input[type="radio"]');radios.length>0&&groups.push({name:text,index:optionIndex,inputs:Array.from(radios)})}}}),groups.sort((a,b)=>a.index-b.index)}function getSelectedOptions(groups){const selected=new Array(product.options.length).fill(null);return groups.forEach(group=>{const checkedInput=group.inputs.find(input=>input.checked);if(checkedInput){const label=document.querySelector(`label[for="${checkedInput.id}"]`),value=label?label.textContent.trim():checkedInput.value;selected[group.index]=value}}),selected}function isOptionAvailable(testOptions,optionIndexToCheck){return optionIndexToCheck===0?!0:variants.some(variant=>{let matches=!0;for(let i=0;i<optionIndexToCheck;i++)if(testOptions[i]&&variant.options[i]!==testOptions[i]){matches=!1;break}return matches?variant.options[optionIndexToCheck]===testOptions[optionIndexToCheck]:!1})}function updateButtons(){isUpdating||(updateTimeout&&clearTimeout(updateTimeout),updateTimeout=setTimeout(()=>{isUpdating=!0;const groups=findOptionGroups(),currentSelection=getSelectedOptions(groups),selectionString=JSON.stringify(currentSelection);if(selectionString===lastSelection){isUpdating=!1;return}lastSelection=selectionString,groups.forEach(group=>{group.inputs.forEach(input=>{const label=document.querySelector(`label[for="${input.id}"]`),value=label?label.textContent.trim():input.value,testSelection=[...currentSelection];testSelection[group.index]=value;const isAvailable=isOptionAvailable(testSelection,group.index),buttonElement=label||input.parentElement;buttonElement&&(isAvailable?(buttonElement.style.opacity="1",buttonElement.style.cursor="pointer",buttonElement.style.pointerEvents="auto",buttonElement.classList.remove("variant-disabled")):(buttonElement.style.opacity="0.3",buttonElement.style.cursor="not-allowed",buttonElement.style.pointerEvents="none",buttonElement.classList.add("variant-disabled")))})}),isUpdating=!1},150))}function attachAllListeners(){const groups=findOptionGroups(),events=["change","click","input"];groups.forEach(group=>{group.inputs.forEach(input=>{events.forEach(eventType=>{input.removeEventListener(eventType,handleInputChange),input.addEventListener(eventType,handleInputChange,!0)});const label=document.querySelector(`label[for="${input.id}"]`);label&&events.forEach(eventType=>{label.removeEventListener(eventType,handleInputChange),label.addEventListener(eventType,handleInputChange,!0)})})})}function handleInputChange(){updateButtons()}function startDOMObserver(){new MutationObserver(mutations=>{mutations.forEach(mutation=>{mutation.type==="attributes"&&mutation.attributeName==="checked"&&mutation.target.type==="radio"&&updateButtons(),mutation.type==="attributes"&&mutation.attributeName==="class"&&updateButtons()})}).observe(document.body,{attributes:!0,attributeFilter:["checked","class"],subtree:!0})}function startPolling(){setInterval(()=>{const groups=findOptionGroups(),currentSelection=getSelectedOptions(groups);JSON.stringify(currentSelection)!==lastSelection&&updateButtons()},500)}setTimeout(()=>{resetAllStyles(),attachAllListeners(),startDOMObserver(),startPolling(),updateButtons()},500),setTimeout(()=>{attachAllListeners(),updateButtons()},2e3)}function cleanupOnPageLoad(){document.querySelectorAll('.product-form__input label, input[type="radio"] + label, .variant-disabled').forEach(el=>{el.style.opacity="",el.style.cursor="",el.style.pointerEvents="",el.classList.remove("variant-disabled")})}cleanupOnPageLoad(),document.readyState==="loading"?document.addEventListener("DOMContentLoaded",initVariantFilter):initVariantFilter(),setTimeout(initVariantFilter,1e3)})();

(function() {
  'use strict';
  
  let updateTimeout = null;
  let isUpdating = false;
  let lastSelection = null;
  
  function initVariantFilter() {
    // Le sélecteur du thème gère déjà ces options avec les données Shopify.
    // Le filtre historique lit aussi les badges RÉSA dans les labels,
    // ce qui produit de fausses incompatibilités et bloque les clics.
    if (document.querySelector('variant-picker script[data-option-state]')) {
      return;
    }

    if (!window.ShopifyProduct || !window.ShopifyProduct.variants) {
      return;
    }
    
    const product = window.ShopifyProduct;
    const variants = product.variants;
    
    function resetAllStyles() {
      const allLabels = document.querySelectorAll(
        '.product-form__input label, ' +
        'input[type="radio"][name*="option"] + label, ' +
        'input[type="radio"][name*="option"] ~ label'
      );
      
      const allInputs = document.querySelectorAll(
        'input[type="radio"][name*="option"]'
      );
      
      allLabels.forEach(label => {
        label.style.opacity = '';
        label.style.cursor = '';
        label.style.pointerEvents = '';
        label.classList.remove('variant-disabled');
      });
      
      allInputs.forEach(input => {
        input.disabled = false;
      });
    }
    
    function findOptionGroups() {
      const groups = [];
      const labels = document.querySelectorAll('.product-form__input label, fieldset legend, .variant-picker__label');
      
      labels.forEach(label => {
        const text = label.textContent.trim().replace(':', '');
        
        if (product.options.includes(text)) {
          const optionIndex = product.options.indexOf(text);
          const container = label.closest('.product-form__input, fieldset, .variant-picker');
          
          if (container) {
            const radios = container.querySelectorAll('input[type="radio"]');
            
            if (radios.length > 0) {
              groups.push({
                name: text,
                index: optionIndex,
                inputs: Array.from(radios)
              });
            }
          }
        }
      });
      
      return groups.sort((a, b) => a.index - b.index);
    }
    
    function getSelectedOptions(groups) {
      const selected = new Array(product.options.length).fill(null);
      
      groups.forEach(group => {
        const checkedInput = group.inputs.find(input => input.checked);
        if (checkedInput) {
          const label = document.querySelector(`label[for="${checkedInput.id}"]`);
          const value = label ? label.textContent.trim() : checkedInput.value;
          selected[group.index] = value;
        }
      });
      
      return selected;
    }
    
    function isOptionAvailable(testOptions, optionIndexToCheck) {
      if (optionIndexToCheck === 0) {
        return true;
      }
      
      return variants.some(variant => {
        let matches = true;
        
        for (let i = 0; i < optionIndexToCheck; i++) {
          if (!testOptions[i]) {
            continue;
          }
          if (variant.options[i] !== testOptions[i]) {
            matches = false;
            break;
          }
        }
        
        if (matches) {
          return variant.options[optionIndexToCheck] === testOptions[optionIndexToCheck];
        }
        
        return false;
      });
    }
    
    function updateButtons() {
      if (isUpdating) {
        return;
      }
      
      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }
      
      updateTimeout = setTimeout(() => {
        isUpdating = true;
        
        const groups = findOptionGroups();
        const currentSelection = getSelectedOptions(groups);
        
        const selectionString = JSON.stringify(currentSelection);
        if (selectionString === lastSelection) {
          isUpdating = false;
          return;
        }
        
        lastSelection = selectionString;
        
        groups.forEach(group => {
          group.inputs.forEach(input => {
            const label = document.querySelector(`label[for="${input.id}"]`);
            const value = label ? label.textContent.trim() : input.value;
            
            const testSelection = [...currentSelection];
            testSelection[group.index] = value;
            
            const isAvailable = isOptionAvailable(testSelection, group.index);
            
            const buttonElement = label || input.parentElement;
            
            if (buttonElement) {
              if (isAvailable) {
                buttonElement.style.opacity = '1';
                buttonElement.style.cursor = 'pointer';
                buttonElement.style.pointerEvents = 'auto';
                buttonElement.classList.remove('variant-disabled');
              } else {
                buttonElement.style.opacity = '0.3';
                buttonElement.style.cursor = 'not-allowed';
                buttonElement.style.pointerEvents = 'none';
                buttonElement.classList.add('variant-disabled');
              }
            }
          });
        });
        
        isUpdating = false;
      }, 150);
    }
    
    function attachAllListeners() {
      const groups = findOptionGroups();
      const events = ['change', 'click', 'input'];
      
      groups.forEach(group => {
        group.inputs.forEach(input => {
          events.forEach(eventType => {
            input.removeEventListener(eventType, handleInputChange);
            input.addEventListener(eventType, handleInputChange, true);
          });
          
          const label = document.querySelector(`label[for="${input.id}"]`);
          if (label) {
            events.forEach(eventType => {
              label.removeEventListener(eventType, handleInputChange);
              label.addEventListener(eventType, handleInputChange, true);
            });
          }
        });
      });
    }
    
    function handleInputChange() {
      updateButtons();
    }
    
    function startDOMObserver() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && 
              mutation.attributeName === 'checked' &&
              mutation.target.type === 'radio') {
            updateButtons();
          }
          
          if (mutation.type === 'attributes' && 
              mutation.attributeName === 'class') {
            updateButtons();
          }
        });
      });
      
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['checked', 'class'],
        subtree: true
      });
    }
    
    function startPolling() {
      setInterval(() => {
        const groups = findOptionGroups();
        const currentSelection = getSelectedOptions(groups);
        const selectionString = JSON.stringify(currentSelection);
        
        if (selectionString !== lastSelection) {
          updateButtons();
        }
      }, 500);
    }
    
    setTimeout(() => {
      resetAllStyles();
      attachAllListeners();
      startDOMObserver();
      startPolling();
      updateButtons();
    }, 500);
    
    setTimeout(() => {
      attachAllListeners();
      updateButtons();
    }, 2000);
  }
  
  function cleanupOnPageLoad() {
    const allElements = document.querySelectorAll(
      '.product-form__input label, ' +
      'input[type="radio"] + label, ' +
      '.variant-disabled'
    );
    
    allElements.forEach(el => {
      el.style.opacity = '';
      el.style.cursor = '';
      el.style.pointerEvents = '';
      el.classList.remove('variant-disabled');
    });
  }
  
  cleanupOnPageLoad();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantFilter);
  } else {
    initVariantFilter();
  }
  
  setTimeout(initVariantFilter, 1000);
  
})();